import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { Icon } from 'tea-component';
import ImageError from '@/pages/home/assets/img/common/image-error.svg';
import './index.scss';
export interface IBasicImageProps {
  style?: React.CSSProperties;
  className?: string;
  // 图片路径
  src: string;
  // 图片提示
  alt?: string;
  // 图片加载失败的缺省图
  errorSrc?: string;
  // 图片加载中图标
  loadingNode?: React.ReactNode;
}

export type TImageStatus = 'loading' | 'error' | 'success';

const BasicImage = (props: IBasicImageProps) => {
  const { style = {}, className, src, alt, loadingNode, errorSrc } = props;

  const [status, setStatus] = useState<TImageStatus>('loading');
  const imgRef = useRef<HTMLImageElement>(null);

  const handleLoad = () => {
    setStatus('success');
  };

  const handleError = () => {
    if (imgRef.current) {
      imgRef.current.src = errorSrc || ImageError;
    }
    setStatus('error');
  };

  return (
    <div
      style={style}
      className={classNames('dbi-basic-image-container', className)}
    >
      {status === 'loading' && (loadingNode || <Icon type="loading" />)}
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        onLoad={handleLoad}
        onError={handleError}
        style={{ display: status === 'loading' ? 'none' : '' }}
      />
    </div>
  );
};

export default BasicImage;
